<template>
  <v-container class="bg-image" fluid fill-height>
    <v-layout column align-center justify-center>
      <v-flex xs8 sm4 md4>
        <login-view
          v-if="loginState === 'LOG_IN'"
          :mail.sync="email"
          :click="logInHandler"
          class="pa-6"
        ></login-view>
        <forgot-view
          v-if="loginState === 'FORGOT_PASSWORD'"
          :mail.sync="email"
          :click="forgotPasswordHandler"
          class="pa-6"
        ></forgot-view>
        <new-view
          v-if="loginState === 'NEW_PASSWORD_REQUIRED'"
          :mail.sync="email"
          :click="newPasswordHandler"
          :user="user"
          class="pa-6"
        ></new-view>
        <change-view
          v-if="loginState === 'CHANGE_PASSWORD'"
          :mail.sync="email"
          :click="ChangePasswordHandler"
          class="pa-6"
        ></change-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.bg-image {
  background-color: #f0f0f0;
  background-image: url('/login_background.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>

<script>
/* eslint no-return-assign: 0 */
import { Auth } from 'aws-amplify';
import EventBus from '@/utils/EventBus';
import '@/components/Login';

export default {
  name: 'Login',
  data() {
    return {
      loginState: 'LOG_IN',
      email: '',
      user: null,
    };
  },
  components: {
  },
  async mounted() {
    EventBus.$on('localUser', (user) => {
      this.user = user;
    });
    EventBus.$on('authState', (data) => {
      this.loginState = data;
    });
  },
  methods: {
    logInHandler(data) {
      if (data) {
        this.loginState = 'NEW_PASSWORD_REQUIRED';
      } else {
        this.loginState = 'FORGOT_PASSWORD';
      }
    },
    forgotPasswordHandler(data) {
      if (data) {
        this.loginState = 'CHANGE_PASSWORD';
      } else {
        this.loginState = 'LOG_IN';
      }
    },
    newPasswordHandler(data) {
      if (data) {
        this.loginState = 'LOG_IN';
      } else {
        this.loginState = 'LOG_IN';
      }
    },
    ChangePasswordHandler(data) {
      if (data) {
        this.loginState = 'LOG_IN';
      } else {
        this.loginState = 'LOG_IN';
      }
    },
    getUser() {
      return Auth.currentAuthenticatedUser().then((user) => {
        if (!user) {
          return null;
        }
        return user;
      }).catch((e) => new Error(e));
    },
  },
};
</script>
